var _defs, _path, _path2, _path3, _rect, _circle, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlock121(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.45 20.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;}.cls-1,.cls-2,.cls-3{stroke:#696969;stroke-miterlimit:10;stroke-width:1.5px;}.cls-2{stroke-linecap:round;}.cls-3{fill:#fff;}.cls-4{fill:#696969;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.28,4.91",
    transform: "translate(-3.77 -1.57)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.26,7.13",
    transform: "translate(-3.77 -1.57)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.8,9.41H7.2a.48.48,0,0,1-.48-.48V7.6A5.28,5.28,0,0,1,12,2.32h0a5.28,5.28,0,0,1,4.36,2.31,4,4,0,0,1,.27.44c.07.12.13.25.19.37",
    transform: "translate(-3.77 -1.57)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 0.75,
    y: 7.54,
    width: 14.95,
    height: 12.56,
    rx: 1.1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 8.37,
    cy: 12.38,
    r: 1.86
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M7.54,13.8H9.2a0,0,0,0,1,0,0v3.32a.76.76,0,0,1-.76.76H8.3a.76.76,0,0,1-.76-.76V13.8a0,0,0,0,1,0,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock121);
export default __webpack_public_path__ + "static/media/unlock121.1bb90dffc39213d0075a8018d90de01f.svg";
export { ForwardRef as ReactComponent };